import Arrow from '../../assets/images/Doodles/arrow_right.svg'

function Article({title, desc, link="http://chihuahuaspin.com"}) {
    return(
        <div className="bg-bluekali-white text-black rounded-t-3xl rounded-br-3xl min-w-48 max-w-56 min-h-60 max-h-80 p-4 flex flex-col justify-between">
            <div className='flex-1 overflow-hidden'>
                <h2 className="font-bold mb-2">{title ? title : "Card Title"}</h2>
                <p className="text-sm line-clamp-6 overflow-hidden">
                {desc ? desc : "Description"}
                </p>
            </div>
        
            <div className='flex w-full justify-end pr-2 mt-4'>
                <a
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className='group h-8 w-8 border-2 border-opacity-25 md:hover:border-opacity-50 rounded-lg border-slate-400 flex justify-center items-center'>
                <img src={Arrow} alt='' className='h-4 w-4 brightness-50 -rotate-45 md:group-hover:brightness-0'/>
                </a>
            </div>
        </div>
    );
}

export default Article